module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_live-chat-74ee4e697dc012e6c41419f87b0fcc7b.svg";